module.exports = __webpack_public_path__ + "static/img/8.5c495f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/home/8.png
// module id = aqJs
// module chunks = 1